/* Pau Pao · Nueva web · JS mínimo (sin dependencias). */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const R = window.ppx.routes;
  const FMT = window.ppx.money || '€{{amount_with_comma_separator}}';
  const money = (cents) => { const n = (cents / 100).toFixed(2); const [e, d] = n.split('.'); const conPuntos = e.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); const conComas = e.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_with_comma_separator' ? `${conPuntos},${d}` : k === 'amount_no_decimals_with_comma_separator' ? conPuntos : k === 'amount_no_decimals' ? conComas : `${conComas}.${d}`); };
  ppx.money = money;

  /* ---------- Medición: eventos propios vía Shopify Customer Events (respetan el consentimiento; no duplican los estándar) ---------- */
  const track = (name, data = {}) => { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, data); } catch (e) {} };
  ppx.track = track;
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.filtros .chip'); if (chip) track('ppx_filtro_edad', { edad: chip.textContent.trim() });
    const ed = e.target.closest('.edad__a'); if (ed) track('ppx_home_edad', { edad: ed.textContent.trim().replace(/\s+/g, ' ') });
    const t = e.target.closest('.carril .tarj a, .sugi__c a, .pieza a'); if (t) track('ppx_recomendacion_click', { origen: t.closest('.carril') ? 'carril' : t.closest('.sugi__c') ? 'cesta' : 'combina', url: t.getAttribute('href') });
  });

  /* ---------- Paneles (dialog nativo) ---------- */
  const abrir = (id) => { const d = document.getElementById(id); if (!d) return; if (!d.open) d.showModal(); document.documentElement.style.overflow = 'hidden'; };
  const cerrar = (d) => { if (d && d.open) d.close(); };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-abre]'); if (a) { e.preventDefault(); abrir(a.dataset.abre); if (a.dataset.abre === 'buscador') setTimeout(() => $('#q-buscar')?.focus(), 50); return; }
    const c = e.target.closest('[data-cierra]'); if (c) { cerrar(c.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG') cerrar(e.target); // clic en el fondo
  });
  document.addEventListener('close', () => { if (!$$('dialog[open]').length) document.documentElement.style.overflow = ''; }, true);

  /* ---------- Cabecera: borde al hacer scroll ---------- */
  const cab = $('[data-cabecera]');
  if (cab) { const f = () => cab.classList.toggle('is-scrolled', scrollY > 8); addEventListener('scroll', f, { passive: true }); f(); }

  /* ---------- Carga de fotos al acercarse a la pantalla (no compiten con lo primero que se ve) ---------- */
  const carga = (img) => { if (!img.dataset.srcset) return; img.sizes = img.dataset.sizes || '100vw'; img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); };
  const ioLz = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { carga(e.target); ioLz.unobserve(e.target); } }), { rootMargin: '700px 0px' }) : null;
  ppx.lz = (raiz = document) => $$('img[data-lz][data-srcset]', raiz).forEach((i) => (ioLz ? ioLz.observe(i) : carga(i)));
  ppx.lz();
  const pista = $('[data-pista]');
  if (pista) { const ya = () => { $$('img[data-lz-gal]', pista).slice(0, 2).forEach(carga); }; ['touchstart', 'pointerdown', 'scroll', 'mouseenter'].forEach((ev) => pista.addEventListener(ev, ya, { once: true, passive: true })); pista.addEventListener('scroll', () => $$('img[data-lz-gal][data-srcset]', pista).forEach((i) => { const f = i.closest('figure'); if (f.offsetLeft < pista.scrollLeft + pista.clientWidth * 2) carga(i); }), { passive: true }); }

  /* ---------- Aparición suave ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.sube').forEach((el) => io.observe(el));
  } else $$('.sube').forEach((el) => el.classList.add('is-in'));

  /* ---------- Buscador con sugerencias ---------- */
  const q = $('[data-sugiere]'), res = $('[data-sugiere-res]');
  if (q && res) {
    let t;
    q.addEventListener('input', () => {
      clearTimeout(t);
      const v = q.value.trim(); if (v.length < 2) { res.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${R.search}/suggest.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`).then((x) => x.json());
          const ps = r.resources.results.products || [];
          res.innerHTML = ps.length
            ? `<ul>${ps.map((p) => `<li><a href="${p.url}">${p.image ? `<img src="${p.image}&width=120" alt="" width="60" height="60" loading="lazy">` : ''}<span><span style="font-family:var(--serif)">${p.title}</span><br><small>${money(Math.round(parseFloat(p.price) * 100))}</small></span></a></li>`).join('')}</ul><p style="margin-top:1.6rem"><a class="enlace" href="${R.search}?q=${encodeURIComponent(v)}&type=product">Ver todos los resultados</a></p>`
            : `<p>No hemos encontrado «${v.replace(/</g, '')}». Prueba con «pelele», «peto» o una edad.</p>`;
        } catch (e) { res.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Cesta ---------- */
  const toast = (msg) => { const t = $('.ppx-toast'); if (!t) return; t.textContent = msg; t.hidden = false; clearTimeout(t._t); t._t = setTimeout(() => (t.hidden = true), 2600); };
  ppx.toast = toast;
  const pintaCesta = (html, n) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nuevo = doc.querySelector('[data-cesta-cuerpo]'); const viejo = $('[data-cesta-cuerpo]');
    if (nuevo && viejo) viejo.innerHTML = nuevo.innerHTML;
    const cabNueva = doc.querySelector('.panel__cab'); const cabVieja = $('#cesta .panel__cab'); if (cabNueva && cabVieja) cabVieja.innerHTML = cabNueva.innerHTML;
    if (typeof n === 'number') $$('[data-cesta-n]').forEach((el) => { el.dataset.n = n; el.textContent = n > 0 ? n : ''; });
  };
  const refresca = async () => {
    const [html, cart] = await Promise.all([
      fetch(`${R.root}?sections=ppx-cart-drawer`).then((r) => r.json()).then((j) => j['ppx-cart-drawer']),
      fetch(`${R.cart}.js`).then((r) => r.json())
    ]);
    pintaCesta(html, cart.item_count);
    document.dispatchEvent(new CustomEvent('ppx:cesta', { detail: cart }));
    return cart;
  };
  ppx.refrescaCesta = refresca;
  ppx.abreCesta = () => abrir('cesta');
  ppx.add = async (items, { abrirCesta = true } = {}) => {
    const r = await fetch(`${R.cartAdd}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'ppx-cart-drawer', sections_url: location.pathname }) });
    const j = await r.json();
    if (!r.ok || j.status) throw new Error(j.description || j.message || 'No se ha podido añadir');
    const cart = await fetch(`${R.cart}.js`).then((x) => x.json());
    if (j.sections && j.sections['ppx-cart-drawer']) pintaCesta(j.sections['ppx-cart-drawer'], cart.item_count); else await refresca();
    document.dispatchEvent(new CustomEvent('ppx:cesta', { detail: cart }));
    if (abrirCesta) abrir('cesta');
    return j;
  };
  const cambia = async (line, quantity) => {
    const cuerpo = $('[data-cesta-cuerpo]'); cuerpo && (cuerpo.style.opacity = '.55');
    try {
      const r = await fetch(`${R.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: 'ppx-cart-drawer,ppx-cesta-pagina', sections_url: location.pathname }) });
      const j = await r.json();
      if (j.status) { toast(j.message || 'No hay más unidades en esta talla'); await refresca(); return; }
      pintaCesta(j.sections['ppx-cart-drawer'], j.item_count);
      const pag = $('[data-cesta-pagina]'); if (pag && j.sections['ppx-cesta-pagina']) { const d = new DOMParser().parseFromString(j.sections['ppx-cesta-pagina'], 'text/html'); const n = d.querySelector('[data-cesta-pagina]'); if (n) pag.innerHTML = n.innerHTML; }
      document.dispatchEvent(new CustomEvent('ppx:cesta', { detail: j }));
    } finally { cuerpo && (cuerpo.style.opacity = ''); }
  };
  document.addEventListener('click', (e) => {
    const ab = e.target.closest('[data-abre-cesta]');
    if (ab && $('#cesta') && !document.body.classList.contains('tpl-cart')) { e.preventDefault(); abrir('cesta'); return; }
    const c = e.target.closest('[data-cant]'); if (c) { e.preventDefault(); cambia(+c.dataset.cant, Math.max(0, +c.dataset.q)); return; }
    const s = e.target.closest('[data-sugi-add]');
    if (s) {
      const sel = s.parentElement.querySelector('[data-sugi-sel]'); s.classList.add('is-loading');
      track('ppx_sugerencia_3x2', { variante: +sel.value });
      ppx.add([{ id: +sel.value, quantity: 1 }], { abrirCesta: true }).catch((er) => toast(er.message)).finally(() => s.classList.remove('is-loading'));
    }
  });
  document.addEventListener('change', (e) => { const i = e.target.closest('[data-cant-input]'); if (i) cambia(+i.dataset.cantInput, Math.max(0, parseInt(i.value || '0', 10))); });

  /* Formularios de añadir genéricos (tarjetas, conjunto…): <form data-ppx-add> con input name=id */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-ppx-add]'); if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]'); btn && btn.classList.add('is-loading');
    const fd = new FormData(f);
    ppx.add([{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }]).catch((er) => toast(er.message)).finally(() => btn && btn.classList.remove('is-loading'));
  });

  /* Abrir la cesta si llega ?cesta=1 */
  if (/[?&]cesta=1/.test(location.search)) addEventListener('load', () => abrir('cesta'));
})();
